// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2PjIQ","clinicsSelect":"styles_clinicsSelect__338ow"};